import React from "react";

import OwlCarousel from "react-owl-carousel";
import fiveStar from "../../../../assets/image/Asset-18.png";
import chatImg from "../../../../assets/image/Asset-17.png";

export default function WhatClientSayCarousel() {
  const options = {
    loop: true,
    margin: 10,
    items: 1,
    navigation: "true",
    dots: true,
    autoplay: true,
    spped: 500,
  };

  const testimonials = [
    {
      text: "My family had a great experience with Milford. Tony was professional, responsive, and helped us with negotiations for the best selling option. Highly recommend their services – they're trustworthy and easy to work with.",
      client: "Fernanda G.",
    },
    {
      text: "We've had an incredibly great experience with Milford Real Estate. We bought and sold with them – they're first class and have the talent to get it done. Thank you team Milford!",
      client: "Heath B.",
    },
    {
      text: "This is our second time with Milford and they always make us feel like family. Tony explained everything clearly and guided us in the right direction. Highly recommend!",
      client: "Crystal M.",
    },
    {
      text: "Hands down the best experience buying and selling a home – every single time. They make you feel like you're the only client in the world. Can't recommend them enough.",
      client: "Mandy D.",
    },
    {
      text: "Karie and the team listened to what we valued and never lost sight of it. They marketed our home creatively and helped us sell at the price we wanted. They became our friends through the process.",
      client: "Brooke P.",
    },
    {
      text: "Milford took us under their wing and made us feel like family. No stress, no pressure – just great communication and a seamless experience. Love them!",
      client: "Allyson Y.",
    },
    {
      text: "Milford is the #1 choice in Omaha, hands down. The team was nonstop in helping us find our dream home. Constant communication, attention to detail, and heart. We ❤️ Milford!",
      client: "Andrea K.",
    },
  ];

  return (
    <>
      <div className="what-client-say-carousel my-5">
        <div className="quotes d-flex align-items-center justify-content-center pt-5">
          <img src={chatImg} alt="Chat icon" />
          <p className="rest-text">TESTIMONIALS</p>
        </div>
        <h1 className="test-heading pt-3 pb-5 text-center">
          What Our Clients Say
        </h1>

        <OwlCarousel className="owl-theme WhatOurClientSay" {...options}>
          {testimonials.map(({ text, client }, index) => (
            <div key={index} className="item container ">
              <div className="d-flex justify-content-center">
                <img
                  src={fiveStar}
                  alt="Five stars"
                  className="five-star-img"
                />
              </div>
              <div className="inner-quotes">
                <div className="comments-txt">
                  <p>"{text}"</p>
                  <p className="client-name">– {client}</p>
                </div>
              </div>
            </div>
          ))}
        </OwlCarousel>
      </div>
    </>
  );
}
